import React, { useContext } from 'react'
import { Link } from 'react-router-dom'

import { DataContext } from '../../Context/DataContext'
import { UIContext } from '../../Context/UIContext'

import MainLogo from './MainLogo'

const HomeLink = ({ minimal, whitemode }) => {
    const { sitename, tagline } = useContext(DataContext)
    const { setMenuOpen, setMemberModalVisible, currentPage } = useContext(UIContext)

    const handleClose = () => {
        setMenuOpen(false)
        setMemberModalVisible(false)
    }

    const content = (
        <>
            <MainLogo minimal={minimal} whitemode={whitemode} />
            <span>{ sitename } | { tagline }</span>
        </>
    )

    return currentPage === 'home' 
        ? <div className="mga-brand" onClick={handleClose}>{content}</div>
        : <Link className="mga-brand" to="/" onClick={handleClose}>{content}</Link>
}

HomeLink.defaultProps = {
    minimal: false,
    whitemode: false,
}

export default React.memo(HomeLink)